module.exports = __webpack_public_path__ + "static/media/log_8.d3a20ece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_8.jpg
// module id = 1897
// module chunks = 0